import React, { useState } from 'react';

import styled from 'styled-components';

import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import InputText from 'apps/auth/components/form-multi/InputText';
import { inputPropType } from 'apps/auth/helpers/customPropTypes';

const TEXT_TYPE = 'text';
const PASSWORD_TYPE = 'password';

export const ToggleButton = styled.div`
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1;
`;

const InputPassword = (props) => {
    const [type, setType] = useState(props.field.type);

    const handlerShowPassword = (e) => {
        e.preventDefault();
        setType(type !== TEXT_TYPE ? TEXT_TYPE : PASSWORD_TYPE);
    };

    const password = props.field;
    password.type = type;
    return (
        <InputText
            field={password}
            formName={props.formName}
            onChangeHandler={props.onChangeHandler}
            onBlurHandler={props.onBlurHandler}
            validateOnBlur={props.validateOnBlur}
            isClearErrorOnFocus={true}
            focus={props.focus}
            isNewInput
        >
            <ToggleButton>
                <DiskButton type="button" iconName={type === TEXT_TYPE ? 'eye' : 'eye-crossed'} raised={false} onClick={handlerShowPassword} />
            </ToggleButton>
        </InputText>
    );
};

InputPassword.propTypes = inputPropType(['password', 'text']);

export default InputPassword;
